import { useMemo } from 'react';
import { Gesture } from 'react-native-gesture-handler';
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withSpring,
  runOnJS,
} from 'react-native-reanimated';

const NUDGE_SPRING = { stiffness: 480, damping: 38, mass: 0.55 };

export type NudgeDirection = 'left' | 'right';

export interface UseNudgeGestureOptions {
  direction: NudgeDirection;
  onEnd: () => void;
  nudgeAmount?: number;
  /** Expands the tap target without changing layout (avoids stacking Tap + Pressable). */
  hitSlop?: { top?: number; bottom?: number; left?: number; right?: number };
}

export function useNudgeGesture(options: UseNudgeGestureOptions): {
  gesture: ReturnType<typeof Gesture.Tap>;
  nudgeStyle: ReturnType<typeof useAnimatedStyle>;
} {
  const { direction, onEnd, nudgeAmount = 6, hitSlop } = options;
  const translateX = useSharedValue(0);
  const offset = direction === 'left' ? -nudgeAmount : nudgeAmount;

  const gesture = useMemo(() => {
    let g = Gesture.Tap()
      .onBegin(() => {
        'worklet';
        translateX.value = withSpring(offset, NUDGE_SPRING);
      })
      .onEnd(() => {
        'worklet';
        runOnJS(onEnd)();
      })
      .onFinalize(() => {
        'worklet';
        translateX.value = withSpring(0, NUDGE_SPRING);
      });
    if (hitSlop) {
      g = g.hitSlop(hitSlop);
    }
    return g;
  }, [onEnd, offset, hitSlop]);

  const nudgeStyle = useAnimatedStyle(() => ({
    transform: [{ translateX: translateX.value }],
  }));

  return { gesture, nudgeStyle };
}
